import angular from 'angular';
import {
  userService,
  loaderService,
  ssDialogService,
  controlDataService,
  controlSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';
import editControlDialog from '../dialog.editControlDialog';
import controller from './control.controller';
import directive from './control.directive';
import deleteControlConfirmDialog from '../dialog.deleteControlConfirmDialog';
import syncControlConfirmDialog from '../dialog.syncControlConfirmDialog';

const controlAdminModule = angular.module('app.components.admin.control', [
  userService,
  alerts,
  actionIcon,
  confirmDialog,
  editControlDialog,
  loaderService,
  ssDialogService,
  controlDataService,
  controlSharedModelService,
  deleteControlConfirmDialog,
  syncControlConfirmDialog
])
  .directive('control', directive)
  .controller('ControlController', controller);

export default controlAdminModule.name;

console.log('app.components.admin.control created');
